import * as Yup from 'yup';
import { Form, FormikProvider, useFormik } from 'formik'
import { Modal } from 'antd';
import { Grid, TextField, Button } from '@material-ui/core';
import { toast } from 'react-toastify';
import { firestore } from '../../config/firebaseConfig';


export default function ContactForm({ visible, handleCancel, contact = null }) {

    const phoneRegExp = /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/

    const formSchema = Yup.object().shape({
        Name: Yup.string().min(2, "Too Short!").required("le champs nom doit etre remplis"),
        Compagny: Yup.string().min(2, "Too Short!").required("le champs compagnie doit etre remplis"),
        Tel: Yup.string().matches(phoneRegExp, "Le numero de telephone invalide").required("champs telephone doit etre remplis"),
         Adresse : Yup.string().min(2, "Too Short!").required("le champs d'adresse doit etre remplis"),
        Post: Yup.string().min(2, "Too Short!").required("le champs Post doit etre remplis"),
        Code: Yup.string().min(2, "Too Short!").required("le champs code doit etre remplis"),
         Region: Yup.string().min(2, "Too Short!").required("le champs region doit etre remplis"),
        Ville: Yup.string().min(2, "Too Short!").required("le champs ville doit etre remplis"),
        Pays: Yup.string().min(2, "Too Short!").required("le champs pays doit etre remplis"),
        Email: Yup.string().min(2, "Too Short!").required("le champs Email doit etre remplis"),
        Site: Yup.string().min(2, "Too Short!").required("le champs Site doit etre remplis"),




    });

    const formik = useFormik({
        enableReinitialize: true,
        initialValues: {
            Name: contact ? contact?.Name : '',
            Compagny: contact ? contact?.Compagny : '',
            Tel: contact ? contact?.Tel : '',
            Adresse : contact ? contact?.Adresse : '',
            Post : contact ? contact?.Post : '',
            Code : contact ? contact?.Code : '',
            Region : contact ? contact?.Region : '',
            Ville : contact ? contact?.Ville : '',
            Pays : contact ? contact?.Pays : '',
            Email: contact ? contact?.Email : '',
            Site : contact ? contact?.Site : ''

        },
        validationSchema: formSchema,
        onSubmit: async (values, { setErrors, setSubmitting, resetForm }) => {
            try {
                let contactRef = firestore.collection('contacts');
                var doc = await contactRef.where("Tel", "==", values.Tel).get()
                if (doc.empty) {
                    await contactRef.add({...values});
                    setSubmitting(false);
                    toast.success("success")
                    resetForm();
                    handleCancel();
                } else {
                    toast.error("Le contact existe déja, utilisez un autre numero")
                }
            } catch (error) {
                setSubmitting(false);
                toast.error("error");
                console.log(error);
                setErrors(error);
            }
        }
    })


    const {
        errors,
        touched,
        isSubmitting,
        handleSubmit,
        getFieldProps,
    } = formik;

    return (

        <Modal title="Ajout de Contact" visible={visible} footer={[]} confirmLoading={isSubmitting} onCancel={handleCancel} width={700} >
            <FormikProvider value={formik}>
                <Form autoComplete="off" noValidate onSubmit={handleSubmit}>
                    <Grid container spacing={2}>
                        <Grid item xs={8} sm={4}>
                            <TextField
                                label="Name"
                                variant="outlined"
                                error={Boolean(touched.Name && errors.Name)}
                                helperText={touched.Name && errors.Name}
                                {...getFieldProps('Name')}
                            />
                        </Grid>
                        <Grid item xs={8} sm={4}>
                            <TextField
                                label="Adresse"
                                variant="outlined"
                                error={Boolean(touched.Adresse && errors.Adresse)}
                                helperText={touched.Adresse && errors.Adresse}
                                {...getFieldProps('Adresse')}
                            />
                        </Grid>
                        <Grid item xs={8} sm={4}>
                            <TextField
                                label="Post"
                                variant="outlined"
                                error={Boolean(touched.Post && errors.Post)}
                                helperText={touched.Post && errors.Post}
                                {...getFieldProps('Post')}
                            />
                        </Grid>
                        <Grid item xs={8} sm={4}>
                            <TextField
                                label="Code Postal"
                                variant="outlined"
                                error={Boolean(touched.Code && errors.Code)}
                                helperText={touched.Code && errors.Code}
                                {...getFieldProps('Code')}
                            />
                        </Grid>
                        <Grid item xs={8} sm={4}>
                            <TextField
                                label="ville"
                                variant="outlined"
                                error={Boolean(touched.Ville && errors.Ville)}
                                helperText={touched.Ville && errors.Ville}
                                {...getFieldProps('Ville')}
                            />
                        </Grid>
                        <Grid item xs={8} sm={4}>
                            <TextField
                                label="Region"
                                variant="outlined"
                                error={Boolean(touched.Region && errors.Region)}
                                helperText={touched.Region && errors.Region}
                                {...getFieldProps('Region')}
                            />
                        </Grid>
                        <Grid item xs={8} sm={4}>
                        <TextField
                            label="Pays"
                            variant="outlined"
                            error={Boolean(touched.Pays && errors.Pays)}
                            helperText={touched.Pays && errors.Pays}
                            {...getFieldProps('Pays')}
                        />
                    </Grid>
                        <Grid item xs={8} sm={4}>
                            <TextField
                                label="Compagny"
                                variant="outlined"
                                error={Boolean(touched.Compagny && errors.Compagny)}
                                helperText={touched.Compagny && errors.Compagny}
                                {...getFieldProps('Compagny')}
                            />
                        </Grid>
                        <Grid item xs={8} sm={4}>
                            <TextField
                                label="Email"
                                variant="outlined"
                                error={Boolean(touched.Email && errors.Email)}
                                helperText={touched.Email && errors.Email}
                                {...getFieldProps('Email')}
                            />
                        </Grid>
                        <Grid item xs={8} sm={4}>
                            <TextField
                                label="Site internet"
                                variant="outlined"
                                error={Boolean(touched.Site && errors.Site)}
                                helperText={touched.Site && errors.Site}
                                {...getFieldProps('Site')}
                            />
                        </Grid>

                        <Grid item xs={8} sm={4}>
                            <TextField
                                label="Tel"
                                variant="outlined"
                                error={Boolean(touched.Tel && errors.Tel)}
                                helperText={touched.Tel && errors.Tel}
                                {...getFieldProps('Tel')}
                            />
                        </Grid>
                    </Grid>
                    <Grid container spacing={2} justify='center' style={{ paddingRight: 20, paddingLeft: 20, paddingTop: 30, marginBottom: 10 }} >
                        <Grid item>
                            <Button onClick={handleCancel} variant="contained" color="default">
                                annuler
                            </Button>
                        </Grid>

                        <Grid item>
                            <Button type="submit" variant="contained" color="primary"  >
                                valider
                            </Button>
                        </Grid>

                    </Grid>

                </Form>
            </FormikProvider>
        </Modal>
    )
}
